/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Filters from '../Filters';
import useForm from '../../hooks/useForm';
import { ControlTable } from '../Table';
import { deleteNotices, getBoardList } from '../../apis/boards';
import { isEmpty } from '../../utils/lodashExtend';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { toggleNotice } from '../../store/actions';
import Profile from '../Profile';
import { dateToFormat, formatDateHour } from '../../utils/date';
import systemAlert from '../../utils/systemAlert';
import ToolTip from '../ToolTip/ToolTip';
import { getAllCareCompanies } from '../../apis/admin/companies';
import { getParams } from '../../utils/params';

const NoticeBoards = () => {
  const { employee } = useSelector(
    (store) => ({
      employee: store.Profile.employee
    }),
    shallowEqual
  );


  const dispatch = useDispatch();
  const [filters] = useState([
    {
      title: "제목",
      key: "search.title"
    },
    {
      title: "내용",
      key: "search.content"
    },
    // {
    //   title: "작성자",
    //   key: "writerEmployee"
    // }
  ]);

  const [fields, setFields] = useState([]);
  const [careCompanies, setCareCompanies] = useState([]);

  const {
    form,
    setSubmit,
    handleOnChange,
    filterSubmit,
    list, setList,
    selectedList, setSelectedList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
    reSubmit
  } = useForm({
    order: [
      {
        createdTime: "desc",
      },
    ],
    limit: 10,
    offset: 0,
    isTax: true,
  });

  const writeNotice = () => {
    dispatch(toggleNotice(true));
  };

  const onDelete = () => {
    systemAlert(`"${selectedList[0].title}" ${selectedList.length > 1 ? `외 ${selectedList.length - 1}개` : ``}를(을) 삭제하시겠습니까?`,
      {
        buttons: [
          {
            label: "취소",
            color: "text"
          },
          {
            label: "삭제",
            color: "red",
            onClick: () => {
              deleteNotices({ idx: selectedList.map(item => item.idx) }, "client_wide_notice").then(res => {
                reSubmit();
                setSelectedList([]);
              });
            }
          }
        ]
      }
    );
  };

  const tableButtons = [{
    label: "삭제",
    disabled: isEmpty(selectedList),
    color: 'red',
    action: onDelete
  }, {
    label: "전체 공지 등록",
    action: writeNotice
  }];

  const submit = (form) => {
    setIsLoading(true);
    getBoardList(getParams(form), 'client_wide_notice')
      .then((res) => {
        const { posts = [], total = 0 } = res.data;
        setList(posts);
        setTotal(total);
      }).finally(() => setIsLoading(false));
  };

  useEffect(() => {
    submit(form);
    setSubmit(submit);
  }, []);

  useEffect(() => {
    if (employee && employee.type > 1) {
      getAllCareCompanies(employee.managerCompanyIdx, employee.type)
        .then(res => {
          setCareCompanies(res.data?.companies || []);
        });
    }
  }, [employee]);

  useEffect(() => {
    if (!isEmpty(careCompanies)) {
      setFields([
        {
          title: '제목',
          key: 'title',
        },

        {
          title: '개시대상',
          key: 'boardToCompanies',
          onValue: (v) => {
            const company = v.find(f => careCompanies.find(ff => ff.companyIdx === f.companyIdx));
            return (
              <span>
                {careCompanies.find(f => company?.companyIdx === f.companyIdx)?.name}
                {v.length > 1 && (
                  <>
                    {` 외 ${v.length - 1}개`}
                    <ToolTip position='right' tooltiptext={
                      careCompanies.filter(
                        f => v.find(ff => ff.companyIdx === f.companyIdx)
                      ).map(item => item.name).join(",")
                    } />
                  </>
                )}
              </span>
            );
          },
        },
        {
          title: '공유타입',
          key: 'share',
          onValue: (d) => d === "notice" ? "공지사항" : "세무사상담",
        },
        {
          title: "개시날짜",
          key: "shareDateTime",
          onValue: (v) => v ? dateToFormat(v, formatDateHour) : "-"
        },
        {
          title: "작성일",
          key: "createdTime", type: 'datetime'
        },
        {
          title: "작성자",
          key: "writeEmployee",
          onValue: (data) => {
            return <Profile data={data} />;
          }
        },
      ]);
    }
  }, [careCompanies]);

  const openNoticeDetail = (data) => {
    dispatch(toggleNotice(data));
  };

  const getCheckboxDisabled = (data) => !!data.shareDateTime;

  return (
    <>
      <Filters
        isLoading={isLoading}
        filters={filters}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange}
      />
      <ControlTable
        isHideAllCheck
        fields={fields}
        list={list}
        isLoading={isLoading}
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        isControl={true}
        buttons={tableButtons}
        selectedList={selectedList}
        setSelected={setSelectedList}
        onSelect={openNoticeDetail}
        checkboxDisabled={getCheckboxDisabled}
      />

    </>
  );
};

export default NoticeBoards;